<form #shareform="ngForm" class="form-horizontal" novalidate (ngSubmit)="onShare(shareform.value, shareform.valid)" (keydown.enter)="$event.preventDefault()"
    autocomplete="nope">
    <nb-card class="dialog-modal-card {{size}}">
        <nb-card-header>{{title}}</nb-card-header>
        <nb-card-body>

            <div class="form-group">
                <div>
                    <label for="formGroupExampleInput">Send Via</label>
                </div>
                <nb-radio-group id="violatio-enforcement-nmethod" name="method" class="radio-group" #method="ngModel"
                    [(ngModel)]="data.sendtype" (valueChange)="onChange($event)">
                    <nb-radio value="email">Email</nb-radio>
                    <nb-radio value="phone">Text Message</nb-radio>
                </nb-radio-group>
            </div>
            <div class="form-group" *ngIf="data.sendtype=='email'">
                <label for="txtEmail" *ngIf="data.sendtype=='email'">Email Address</label>
                <input type="text" class="form-control" id="txtEmail" placeholder="recipient@example.com"  nbInput fullWidth />
                <div class="alert alert-danger" *ngIf="checkEmailEmpty()" style="position: absolute; z-index: 100;">
                    <div>Email is required</div>
                </div>
            </div>
            <div class="form-group" *ngIf="data.sendtype=='phone'">
                <label for="txtPhone" *ngIf="data.sendtype=='phone'">Phone Number</label>
                <input id="txtPhone" class="form-control" name="txtPhone" type="tel" placeholder='Phone Number'
                    *ngIf="data.sendtype=='phone'" ngModel #txtPhone="ngModel" [(ngModel)]="data.txtPhone" (keypress)="phoneNumberOnly($event)"  />
                <div class="alert alert-danger" *ngIf="data.sendtype=='phone' && ((submitted && phoneNumberError))" style="position: absolute; z-index: 100;">
                    <div *ngIf="phoneNumberError">Please enter a valid phone number with at least 9 digits.</div>
                </div>
            </div>
            <div class="form-group">
                <label for="txtDescription">Description</label>
                <textarea class="form-control" id="txtDescription" name="txtDescription" rows="4" maxlength="250"
                    fullWidth ngModel #txtDescription="ngModel" [(ngModel)]="data.txtDescription"></textarea>
            </div>
            <div class="form-group">
                <label for="dtExpireDate">Expiration Date</label>
                <div class="datepicker-container">
                    <input type="text" #datepicker [nbDatepicker]="dateTimePicker" class="form-control input-date"
                        id="txtDate" placeholder="Select a date" 
                        nbInput fullWidth  [(ngModel)]="data.txtDate" [ngModelOptions]="{ standalone: true }" readonly/>
                    <nb-datepicker id="ndDate" #dateTimePicker [filter]="filterFn"></nb-datepicker>
                </div>
            </div>
            <div class="form-group">
                <label for="txtPass">Require PIN Code</label>
                <input type="password" class="form-control" id="txtPass" name="txtPass"   [(ngModel)]="data.txtPass" 
                    placeholder="Enter 4-Digit PIN Code" ngModel #txtPass="ngModel"  minlength="4"  maxlength="4"  (keypress)="numberOnly($event)"   />
                <div class="input alert alert-danger" *ngIf="(submitted && !txtPass.valid)" style="position: absolute; z-index: 100;">
                    <div>Pin should be minimum 4 characters.</div>
                </div>
                
            </div>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" id="chkDownload" name="chkDownload" ngModel
                    #chkDownload="ngModel" [(ngModel)]="data.chkDownload" />
                <label class="form-check-label" for="chkDownload" >
                    Disable Download
                </label>
            </div>
            <button type="submit" hidden #btn></button>
        </nb-card-body>
        <nb-card-footer>

            <button nbButton status="success" (click)="btn.click()">SHARE</button>
            <button nbButton status="danger" (click)="dismiss()">CANCEL</button>
        </nb-card-footer>
    </nb-card>
</form>